(() => {
  if (customElements.get('mossieck-stempel-editor')) return;
  const NS = 'http://www.w3.org/2000/svg';
  class StampEditor extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.svg = this.querySelector('svg');
      this.status = this.querySelector('.mse-status');
      this.button = this.querySelector('button[type=submit]');
      this.available = !this.button.disabled;
      this.context = document.createElement('canvas').getContext('2d');
      const dimensions = this.dataset.title.match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*mm/i);
      this.widthMm = dimensions ? Number(dimensions[1].replace(',', '.')) : 0;
      this.heightMm = dimensions ? Number(dimensions[2].replace(',', '.')) : 0;
      this.imageData = null;
      this.fileError = '';
      this.pdf = false;
      this.fileToken = 0;
      this.filePending = false;
      this.form.addEventListener('input', event => this.changed(event));
      this.form.addEventListener('change', event => this.changed(event));
      this.field('Vorlage').addEventListener('change', () => this.loadFile());
      this.form.addEventListener('submit', event => {
        this.update();
        if (!this.valid || !this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.status.scrollIntoView({block:'nearest'});
        }
      }, true);
      this.update();
    }
    field(name) { return this.form.elements.namedItem('properties[' + name + ']'); }
    changed(event) { if (!['properties[Text und Gestaltung geprüft]','quantity'].includes(event.target.name)) this.field('Text und Gestaltung geprüft').checked = false; this.update(); }
    async loadFile() {
      const token = ++this.fileToken;
      const file = this.field('Vorlage').files[0];
      this.imageData = null; this.fileError = ''; this.pdf = false; this.filePending = false;
      this.field('Vorlage').setCustomValidity('');
      if (!file) { this.update(); return; }
      if (file.size > 10 * 1024 * 1024) this.fileError = 'Die Vorlage ist größer als 10 MB. Bitte wählen Sie eine kleinere Datei.';
      else if (!['image/png','image/jpeg','application/pdf'].includes(file.type)) this.fileError = 'Bitte wählen Sie eine PNG-, JPG- oder PDF-Datei.';
      else if (file.type === 'application/pdf') this.pdf = true;
      else {
        this.filePending = true; this.update();
        try {
          const data = await new Promise((resolve,reject) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = reject; r.readAsDataURL(file); });
          const img = new Image(); img.src = data; await img.decode();
          if (token !== this.fileToken) return;
          // Bound preview size; the original file is preserved in the product form.
          const canvas = document.createElement('canvas'); const scale = Math.min(1,1200/Math.max(img.width,img.height));
          canvas.width = Math.max(1,Math.round(img.width*scale)); canvas.height = Math.max(1,Math.round(img.height*scale));
          canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);
          this.imageData = canvas.toDataURL('image/png');
        } catch { if (token === this.fileToken) this.fileError = 'Das Bild konnte nicht gelesen werden. Bitte wählen Sie eine andere Datei.'; }
        if (token !== this.fileToken) return;
        this.filePending = false;
      }
      this.field('Vorlage').setCustomValidity(this.fileError); this.update();
    }
    node(tag,attrs={}) { const n = document.createElementNS(NS,tag); Object.entries(attrs).forEach(([k,v])=>n.setAttribute(k,String(v))); return n; }
    update() {
      const text = this.field('Stempeltext').value.replace(/\r/g,'');
      const lines = text.split('\n');
      const font = this.field('Schriftart').value;
      const points = Number(this.field('Schriftgröße pt').value);
      const mm = points * 25.4 / 72;
      this.field('Schriftgröße mm').value = Number.isFinite(mm) ? mm.toFixed(3) : '';
      const bold = this.field('Fettdruck').checked;
      const alignment = this.field('Ausrichtung').value;
      const w = this.widthMm, h = this.heightMm;
      const margin = 1;
      const logoHeight = this.imageData ? Math.min(h * 0.38, h-2) : 0;
      const lineHeight = mm * 1.2;
      const textHeight = lines.length * lineHeight;
      const contentHeight = (text.trim() ? textHeight : 0) + logoHeight + (logoHeight && text.trim() ? 1 : 0);
      this.context.font = (bold?'bold ':'') + (mm * 10) + 'px "' + font + '"';
      const maxWidth = Math.max(0,...lines.map(line=>this.context.measureText(line).width / 10));
      let error = '';
      if (!w || !h || w <= 2 || h <= 2) error = 'Für dieses Modell bitte die Gestaltung persönlich mit uns abstimmen.';
      else if (this.filePending) error = 'Die Bildvorschau wird geladen …';
      else if (this.fileError) error = this.fileError;
      else if (!Number.isFinite(points) || points < 6 || points > 22) error = 'Bitte wählen Sie eine Schriftgröße zwischen 6 und 22 Punkt.';
      else if (!text.trim() && !this.field('Vorlage').files.length) error = 'Bitte geben Sie Ihren Stempeltext ein oder laden Sie eine fertige Vorlage hoch.';
      else if (text.trim() && (maxWidth > w - 2 * margin || contentHeight > h - 2 * margin)) error = 'Die Gestaltung passt noch nicht in die Abdruckfläche. Bitte verkleinern Sie die Schrift oder kürzen Sie den Text.';
      this.valid = !error;
      this.button.disabled = !this.available || !this.valid;
      this.status.dataset.error = String(!!error);
      this.status.textContent = error || ('Abdruckfläche: ' + w + ' × ' + h + ' mm.' + (this.pdf ? ' Die PDF-Vorlage wird vor der Fertigung geprüft; sie ist hier nicht abgebildet.' : ' Die Gestaltung passt in die Vorschau.'));
      this.field('Stempeltext').required = !this.field('Vorlage').files.length;
      this.field('Abdruckfläche').value = w + ' × ' + h + ' mm';
      this.field('_Stempelentwurf').value = JSON.stringify({version:2,widthMm:w,heightMm:h,text,font,fontSizePt:points,fontSizeMm:mm,bold,alignment,logoLayout:this.imageData?'oben-mittig':null,previewMarginMm:margin,previewLineHeight:1.2,hasPdf:this.pdf});
      this.svg.replaceChildren(); this.svg.setAttribute('viewBox',`0 0 ${w || 58} ${h || 22}`);
      this.svg.append(this.node('rect',{x:0,y:0,width:w||58,height:h||22,fill:'#fff',stroke:'#7c969b','stroke-width':.3}));
      const clipId = this.form.id + '-clip'; const defs=this.node('defs'); const clip=this.node('clipPath',{id:clipId}); clip.append(this.node('rect',{x:margin,y:margin,width:Math.max(0,w-2*margin),height:Math.max(0,h-2*margin)})); defs.append(clip); this.svg.append(defs);
      const content=this.node('g',{'clip-path':`url(#${clipId})`}); this.svg.append(content);
      let top = (h-contentHeight)/2;
      if (this.imageData) { content.append(this.node('image',{href:this.imageData,x:margin,y:Math.max(margin,top),width:w-2*margin,height:logoHeight,preserveAspectRatio:'xMidYMid meet'})); top += logoHeight + (text.trim()?1:0); }
      const x = alignment==='Linksbündig'?margin:alignment==='Rechtsbündig'?w-margin:w/2;
      const anchor = alignment==='Linksbündig'?'start':alignment==='Rechtsbündig'?'end':'middle';
      if (text.trim() && Number.isFinite(mm)) lines.forEach((line,index)=>{const n=this.node('text',{x,y:top+mm+index*lineHeight,'font-family':font,'font-size':mm,'font-weight':bold?700:400,'text-anchor':anchor,fill:error?'#a02721':'#111'});n.textContent=line;content.append(n);});
    }
  }
  customElements.define('mossieck-stempel-editor',StampEditor);
})();
